import {
  FormControl,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  AdditionalOptions,
  buildDynamicDownloadUrl,
  downloadImage,
  DownloadOptions,
} from "../Utilities";
import InfoIcon from "@mui/icons-material/Info";
import {
  extensionOptions,
  colorOptions,
} from "../configurations/cropTemplateDownloadOptions";
import ButtonWithProgress from "./ButtonWithProgress";

export default function TemplateRowForm(options: DownloadOptions) {
  let [dynamicUrl, setDynamicUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [formValues, setFormValues] = useState<AdditionalOptions>({
    extension: extensionOptions[0].label,
    color: colorOptions[0].label,
    maxFileSize: "",
  });
  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormValues((prevValues) => ({ ...prevValues, [id]: value }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    downloadCrop();
  };

  function downloadCrop() {
    (async () => {
      try {
        let dynamicUrl = await buildDynamicDownloadUrl(options, formValues);
        setDynamicUrl(dynamicUrl);
      } catch (error) {
        console.log("Error during buildDynamicDownloadUrl: " + error);
        setError(true);
        setSuccess(false);
        setLoading(false);
        setErrorMessage(error);
      }
    })();
  }

  const downloadDynamicUrl = useCallback(() => {
    console.log("Starting downloadImage...");
    downloadImage(dynamicUrl, options.uuid, options.template);
    setLoading(false);
    setSuccess(true);
    setError(false);
    setErrorMessage(null);
    setDynamicUrl(null);
  }, [dynamicUrl, options.uuid, options.template]);

  useEffect(() => {
    //ogni volta che dynamicUrl cambia avviamo il download
    if (dynamicUrl) {
      downloadDynamicUrl();
    }
  }, [dynamicUrl, downloadDynamicUrl]);

  return (
    <FormControl component="form" onSubmit={handleSubmit}>
      <Stack spacing={5} direction="row">
        <TextField
          id="extension"
          select
          //defaultValue={extensionOptions[0]}
          SelectProps={{ native: true }}
          variant="standard"
          value={formValues.extension}
          onChange={handleChange}
          sx={{ marginTop: "15px !important", width: "90px" }}
        >
          {extensionOptions.map((option) => (
            <option key={option.id} value={option.label}>
              {option.label}
            </option>
          ))}
        </TextField>

        <TextField
          id="color"
          select
          //defaultValue={colorOptions[0]}
          SelectProps={{ native: true }}
          value={formValues.color}
          onChange={handleChange}
          variant="standard"
          sx={{ marginTop: "15px !important", width: "90px" }}
        >
          {colorOptions.map((option) => (
            <option key={option.id} value={option.label}>
              {option.label}
            </option>
          ))}
        </TextField>

        <TextField
          id="maxFileSize"
          type="number"
          InputProps={{
            endAdornment: <InputAdornment position="end">kB</InputAdornment>,
          }}
          variant="standard"
          label="Max File Size"
          value={formValues.maxFileSize}
          onChange={(e) => {
            const value = parseFloat(e.target.value);
            if (value >= 0) {
              handleChange(e); // Call your original handler if value is valid
            } else {
              handleChange({ ...e, target: { ...e.target, value: 0 } }); // Reset to 0 if value is negative
            }
          }}
        />
        <ButtonWithProgress
          type="submit"
          variant="contained"
          color="primary"
          loading={loading}
          success={success}
          error={error}
        >
          Download
        </ButtonWithProgress>

        <div
          className={`mt-auto mb-auto ${error === true ? "visible" : "invisible"} `}
        >
          <Tooltip title={errorMessage} placement="top-start">
            <InfoIcon color="error" />
          </Tooltip>
        </div>
      </Stack>
    </FormControl>
  );
}
